import { render, staticRenderFns } from "./blinkist-account.vue?vue&type=template&id=f16e3422&"
import script from "./blinkist-account.vue?vue&type=script&lang=js&"
export * from "./blinkist-account.vue?vue&type=script&lang=js&"
import style0 from "./blinkist-account.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports